import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import RewardsPage from "@/pages/Rewards";
import RewardsPreview from "@/pages/RewardsPreview";
import { useAuth } from "@/hooks/useAuth";

// Signed-in visitors get the real rewards dashboard. Signed-out visitors
// used to hit AuthGate, which renders nothing at all while it redirects to
// /auth -- a real gap for a rewards/incentive page, which should sell
// itself before asking for a signup. RewardsPreview fills that gap.
const RewardsRoute = () => {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <RewardsPage /> : <RewardsPreview />;
};

export const Route = createFileRoute("/rewards")({
  head: () => seoHead("/rewards"),
  component: RewardsRoute,
});
